import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    border: `1px solid ${theme.palette.grey[300]}`,
    borderRadius: 8,
    padding: theme.spacing(2),
    margin: '12px 0'
  },
  header: {
    fontWeight: 600,
    color: theme.palette.text.primary
  },
  subTitle: {
    color: theme.palette.grey[600],
    fontSize: 13,
    fontWeight: 500,
    marginBottom: theme.spacing(2)
  },
  input: {
    maxWidth: 320
  },
  main: { display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', marginTop: 24 }
}))
export default useStyles
